import { Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import StyledDateInput from 'components/styledInput/StyledDateInput';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';
import { useState } from 'react';
import DatePicker from 'react-datepicker';

const AttenteRecrutement = () => {
  const { dataCreateMission, setDataCreateMission, language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`missionCreation.motifForm.${key}`, fallback);
  const { toggle } = useModal();

  const [message, setMessage] = useState(() => {
    if (dataCreateMission?.motif?.type === '2') {
      return {
        type: '2',
        name: dataCreateMission.motif.name || '',
        prenom: dataCreateMission.motif.prenom || '',
        date: dataCreateMission.motif.date || '',
      };
    }
    return { type: '2', name: '', prenom: '', date: '' };
  });

  const [errorName, setErrorName] = useState(false);
  const [errorPrenom, setErrorPrenom] = useState(false);
  const [errorDate, setErrorDate] = useState(false);

  const handleChange = (field) => (e) => {
    const { value } = e.target;
    setMessage((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    setErrorName(!message.name);
    setErrorPrenom(!message.prenom);
    setErrorDate(!message.date);

    if (message.name && message.prenom && message.date) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: message,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {text('titles.awaitingRecruitment', 'En attente de recrutement')}
      </Modalheader>
      <ModalBody>
        <div className="grid grid-cols-2 gap-6">
          <div className="flex flex-col gap-1.5">
            <StyledInput
              type={'text'}
              label={text('name', 'Nom')}
              value={message.name}
              onChange={handleChange('name')}
            />
            {errorName && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('nameMissing', 'Un nom est requis')}
              </p>
            )}
          </div>
          <div className="flex flex-col gap-1.5">
            <StyledInput
              type={'text'}
              label={text('firstname', 'Prénom')}
              value={message.prenom}
              onChange={handleChange('prenom')}
            />
            {errorPrenom && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('firstnameMissing', 'Un prénom est requis')}
              </p>
            )}
          </div>
          <div className="col-span-2 flex flex-col gap-1.5">
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={message.date}
              onChange={(date) => setMessage((prev) => ({ ...prev, date }))}
              peekNextMonth
              locale="fr-FR"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              popperPlacement="bottom"
              customInput={<StyledDateInput label={text('date', 'Date')} />}
            />
            {errorDate && (
              <p className="text-yellow-400 flex items-center gap-4">
                <Information wh={16} color={'#FFA43D'} />
                {text('dateMissing', 'Une date est requise')}
              </p>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          {text('cancel', 'Annuler')}
        </Button>
        <Button size={'LG'} onClick={handleSubmit}>
          {text('confirm', 'Confirmer')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default AttenteRecrutement;
